<template>
    <v-btn
        fab
        small
        color="#F4F6F8"
        elevation="0"
        @click="handleClick"
        class="mt-2"
    >
        <v-icon color="#A5ACB4">
            mdi-magnify
        </v-icon>
    </v-btn>
</template>

<script>
export default {
    name: 'SearchButton',
    methods: {
        handleClick() {
            this.$emit('click')
        }
    }
}
</script>